import { SecsData, SecsMessage } from '../types/secs';
import secsMessagesData from '../../data/secs-messages.json';

export const secsData: SecsData = secsMessagesData as SecsData;

export function getAllMessages(): SecsMessage[] {
  const messages: SecsMessage[] = [];

  Object.values(secsData.streams).forEach(stream => {
    Object.values(stream.functions).forEach(func => {
      func.id = `S${func.stream}F${func.function}`;
      messages.push(func);
    });
  });

  return messages;
}

export function getMessageById(messageId: string): SecsMessage | null {
  const [stream, func] = messageId.split('F');
  const streamKey = stream;
  const funcKey = `F${func}`;

  return secsData.streams[streamKey]?.functions[funcKey] || null;
}

export function getStreamMessages(streamId: string): SecsMessage[] {
  const stream = secsData.streams[streamId];
  if (!stream) return [];

  return Object.values(stream.functions);
}

export function formatMessageId(stream: number, func: number): string {
  return `S${stream}F${func}`;
}

export function getMessageDisplayName(message: SecsMessage): string {
  return `${formatMessageId(message.stream, message.function)} - ${message.name}`;
}

export function getDirectionLabel(direction: string): { text: string; color: string } {
  switch (direction) {
    case 'H->E':
      return { text: 'Host → Equipment', color: 'text-blue-600 dark:text-blue-400' };
    case 'E->H':
      return { text: 'Equipment → Host', color: 'text-green-600 dark:text-green-400' };
    case 'H<->E':
      return { text: 'Bidirectional', color: 'text-purple-600 dark:text-purple-400' };
    default:
      return { text: direction, color: 'text-gray-600 dark:text-gray-400' };
  }
}

export function getMessageTypeLabel(messageType: string): { text: string; color: string } {
  return messageType === 'primary'
    ? { text: 'Primary', color: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200' }
    : { text: 'Secondary', color: 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200' };
}
